module.exports = __webpack_public_path__ + "static/media/sample_lmfreights.2ea624e6.csv";